import OptionAggregatedTable from './OptionAggregatedTable';
export default OptionAggregatedTable;
